module.exports = __webpack_public_path__ + "./docs/img/icon-ref_folder.5365cf4647e0d9c0c33ffef7fb374e39.svg";